import * as R from 'ramda';

import getFilters from '../../selectors/getSelectedFilters';
import sportsApi from '../../utils/sportsApi';
import getUseRightsholderAttribution from '../../utils/getUseRightsholderAttribution';

const getBroadcastNames = store => async state => {
    try {
        const userClientId = state.user.selectedUserClientId;
        const filters = state.clients[userClientId].filters;

        // Sets filters as loading
        const loadingState = R.assocPath(
            ['clients', userClientId, 'broadcasts', 'isLoading'],
            true,
            state,
        );

        store.setState(loadingState);

        // Append rightsholder logo to the payload

        const { broadcasts: currentBroascasts } = R.path(
            ['clients', userClientId],
            store.getState(),
        );

        const overrides = currentBroascasts.filtersOverride || {};
        const globFilters = getFilters(filters);
        const useRightsholderAttribution = getUseRightsholderAttribution(
            state.user.clientsById[state.user.selectedClientId],
            state.user.selectedClientId,
        );

        const domainObject = R.omit(['accountOwnershipTypeIds'], {
            client: { id: userClientId },
            orderBy: ['contentDate'],
            accountUsernames: globFilters.networks,
            ...(useRightsholderAttribution
                ? { useRightsholderAttribution: true }
                : {}),
            ...globFilters,
            ...overrides,
        });

        const payload = {
            action: 'fetchQuery',
            domainObject,
        };

        const names = await sportsApi
            .url('/media-uploads/broadcasts/names')
            .json(payload)
            .post()
            .json();

        const lastState = store.getState();

        store.setState(
            R.evolve(
                {
                    clients: {
                        [userClientId]: {
                            broadcasts: {
                                names: R.always(names),
                            },
                        },
                    },
                },
                lastState,
            ),
            true,
        );
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

export default getBroadcastNames;
